export const OAuthSettings = {
    appId: '392957f7-b42b-4b78-a457-7a9c3a08ca35',
    redirectUri: 'https://crm.vistingo.com',
    scopes: [
      "user.read",
      "mailboxsettings.read",
      "calendars.readwrite"
    ]
};  